import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-coming-soon',
  template: `
    <div class="p-6 lg:p-8">
      <app-empty-state
        icon="construction"
        [title]="title"
        [description]="description"
      ></app-empty-state>
    </div>
  `,
})
export class ComingSoonComponent {
  @Input() title = 'Coming Soon';
  @Input() description = 'This feature is under active development. Check back soon.';
}
